/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import FlatList from 'flatlist-react';
import { Row, Col, Nav } from 'react-bootstrap';
// import { AppCard, IAppCardList } from "@vlinder-web/app-card-widget-react";
import { AppCard, IAppCardList } from './widget';
import {
  StateOSD,
  IStateOSDProps,
} from '@vlinder-web/state-osd-v2-widget-react';

import { useTheme } from '../../../../providers/theme';

import * as S from './styles';

interface IAppCardListCompProps {
  appCardList: IAppCardList[];
  appCardGridRow?: {
    xs: 1 | 2 | 3 | 4;
    md: 1 | 2 | 3 | 4;
    lg: 1 | 2 | 3 | 4;
  };
  onCardClick?(items: any): void;
  totalCount: number;
  totalPages: number;
  activePage: number;
  onPageChange?(page: number): void;
  emptyListProps?: IStateOSDProps;
  defaultSelected?: IAppCardList[];
}

export const UserGroupListComp = ({
  appCardList,
  gridRow,
  onCardClick,
  emptyListProps,
  defaultSelected,
}: IAppCardListCompProps) => {
  const [cardItems, setCardItems] = useState(
    appCardList?.map((u) =>
      defaultSelected?.includes(u?.appCardId)
        ? { ...u, selected: true }
        : { ...u, selected: false }
    )
  );

  const theme = useTheme();
  const onCardItemClick = (appCard: any) => {
    const _newCardItems = cardItems.map((u) =>
      u.appCardId === appCard?.appCardId ? { ...u, selected: !u.selected } : u
    );
    setCardItems(_newCardItems);

    let _selectedCards = _newCardItems?.filter((u) => u.selected);
    onCardClick && onCardClick(_selectedCards);
  };

  const _renderItem = (appCard: any, index: number) => {
    return (
      <Col
        key={`app-card-col-${index}`}
        xs={gridRow?.xs ? 12 / gridRow?.xs : 12}
        md={gridRow?.md ? 12 / gridRow?.md : 12}
        lg={gridRow?.lg ? 12 / gridRow?.lg : 12}
        style={S.CardContainerStyle}
        onClick={() => onCardItemClick(appCard)}
      >
        <AppCard
          {...(appCard || { appCardId: index })}
          hoverColor={theme?.colors?.secondaryAlt}
        />
      </Col>
    );
  };
  return (
    <>
      <Row>
        <FlatList
          list={cardItems}
          renderItem={_renderItem}
          renderWhenEmpty={() => <StateOSD {...(emptyListProps || {})} />}
        />
      </Row>
    </>
  );
};

UserGroupListComp.defaultProps = {
  appCardList: [],
  defaultSelected: [],
};
